import { createSelector } from '@reduxjs/toolkit';
import { EGarageUtility } from '../../../../packages/JsonQuery';
import {
  selectHasElectricity,
  selectHasExtinguishingSystem,
  selectHasHeating,
  selectHasWater,
} from 'shared/selectors/jsonQuery';

export const selectGarageUtilitiesValue = createSelector(
  [selectHasElectricity, selectHasWater, selectHasHeating, selectHasExtinguishingSystem],
  (hasElectricity, hasWater, hasHeating, hasExtinguishingSystem) => {
    const garageUtilities: EGarageUtility[] = [];

    if (hasElectricity) {
      garageUtilities.push(EGarageUtility.Electricity);
    }

    if (hasHeating) {
      garageUtilities.push(EGarageUtility.Heating);
    }

    if (hasWater) {
      garageUtilities.push(EGarageUtility.Water);
    }

    if (hasExtinguishingSystem) {
      garageUtilities.push(EGarageUtility.ExtinguishingSystem);
    }

    return garageUtilities.length > 0 ? garageUtilities : [null];
  },
);
